/** Tooltip copy for Group Leader and Mission Trip Leader used in Add Group form and Group Dashboard. */

export const GROUP_LEADER_INFO =
  'Type a name and fill email and phone below. If not in the list, they will be added to ReliefHub when you save.'

export const MISSION_TRIP_LEADER_INFO =
  'Type a name and fill email and phone below. If not in the list, they will be added to ReliefHub when you save. Sometimes a group is approved with no mission leader assigned; choose "No ML Approved" in that case.'
